module.exports = __webpack_public_path__ + "static/media/ICON_LENS_CARE_ACTIVE.ad4fa64c.svg";